<template>
    <v-simple-table>
        <tbody>
            <tr>
                <th>Name</th>
                <td>{{ data.name }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: "SupplierGroup",
    props: {
        value: Object
    },
    data() {
        return {
            data: {}
        }
    },
    mounted() { 
        if(this.value){
            this.data = {...this.value}
        }
    }
}
</script>

<style>

</style>